<template>
  <Transition
    enter-active-class="transition-all duration-150 ease-out"
    leave-active-class="transition-all duration-150 ease-in"
    enter-from-class="opacity-0 translate-y-2"
    leave-to-class="opacity-0 translate-y-2"
  >
    <button
      v-if="visible"
      class="fixed bottom-[calc(env(safe-area-inset-bottom)+93px)] tablet-h:bottom-[20px] left-1/2 -translate-x-1/2 z-50 h-[29px] flex items-center gap-x-[8px] pl-[14px] pr-[14px] rounded-full bg-white/90 hover:bg-white border border-[#979797]/15 cursor-pointer transition-colors"
      :style="{
        boxShadow:
          '0 7px 15px -10px #32325d40, 0 4px 25px 0 #0000000d, 0 4px 15px -10px #00000033',
      }"
      @click="emit('click')"
    >
      <ArrowUpIcon class="size-3 text-black" />
      <span class="font-medium text-[13px] leading-[17px] text-black">
        {{ label }}
      </span>
    </button>
  </Transition>
</template>

<script setup lang="ts">
import { ArrowUpIcon } from '@dacr/icons'

defineProps<{
  visible: boolean
  label: string
}>()

const emit = defineEmits<{
  click: []
}>()
</script>
